import { toast as svelteToast } from "@zerodevx/svelte-toast"

const themes = {
  success: {
    "--toastBackground": "#10b981",
    "--toastProgressBackground": "#047857"
  },
  error: {
    "--toastBackground": "#ef4444",
    "--toastProgressBackground": "#b91c1c"
  },
  warning: {
    "--toastBackground": "#f59e0b",
    "--toastProgressBackground": "#b45309"
  },
  info: {
    "--toastBackground": "#3b82f6",
    "--toastProgressBackground": "#1d4ed8"
  }
}

/**
 *
 * @param {String} text
 * @param {String} theme Values are ["success", "error", "info", "warning"]
 * @param {Object} options An object of options for @zerodevx/svelte-toast
 */
export const toast = (
  text: string,
  theme: string,
  options = { duration: 5000 }
) => {
  svelteToast.pop()
  return svelteToast.push(text, { theme: themes[theme], ...options })
}
